"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlatColumnTree = exports["default"] = void 0;
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var appDefs = window.cccisd.appDefs || {};
var levels = {
  groups: {
    rows: (0, _get2["default"])(appDefs, 'pawn.groups', []).map(function (item) {
      return {
        value: item.handle,
        label: item.label
      };
    }),
    key: 'group.groupId',
    initialColumns: [{
      id: 1,
      name: 'group.groupId',
      query: 'group.groupId',
      label: 'Group ID',
      type: 'number',
      alignment: 'left',
      filter: true,
      sort: true
    }, {
      id: 2,
      name: 'group.label',
      query: 'group.label',
      label: 'Label',
      type: 'string',
      alignment: 'left',
      filter: true,
      sort: true
    }],
    tree: [{
      label: 'About group',
      children: ['group.groupId', 'group.label']
    }],
    ancestorKey: 'parentGroups'
  },
  roles: {
    rows: (0, _get2["default"])(appDefs, 'pawn.roles', []).map(function (item) {
      return {
        value: item.handle,
        label: item.label
      };
    }),
    key: 'pawn.pawnId',
    initialColumns: [{
      id: 1,
      name: 'pawn.pawnId',
      query: 'pawn.pawnId',
      label: 'System ID',
      type: 'number',
      alignment: 'left',
      filter: true,
      sort: true
    }],
    tree: [{
      label: 'Respondent fields',
      children: []
    }, {
      label: 'Respondent info',
      children: ['pawn.pawnId', 'pawn.createdDate', 'pawn.roleName']
    }],
    ancestorKey: 'membersOf'
  }
};
var allColumns = function () {
  if (process.env.NODE_ENV === 'test') {
    return {};
  }
  var columns = {
    'pawn.pawnId': {
      label: 'System ID',
      type: 'number'
    },
    'pawn.createdDate': {
      label: 'Created Date',
      type: 'string'
    },
    'pawn.roleName': {
      label: 'Role',
      type: 'string'
    },
    'group.groupId': {
      label: 'Group ID',
      type: 'number'
    },
    'group.label': {
      label: 'Label',
      type: 'string'
    },
    'user.username': {
      label: 'Username',
      type: 'string'
    },
    'user.firstName': {
      label: 'First Name',
      type: 'string'
    },
    'user.lastName': {
      label: 'Last Name',
      type: 'string'
    },
    'user.fullName': {
      label: 'Full Name',
      type: 'string'
    },
    'user.fullNameWithEmail': {
      label: 'Full Name with Email',
      type: 'string'
    },
    'user.fullNameWithUsername': {
      label: 'Full Name with Username',
      type: 'string'
    },
    'user.email': {
      label: 'Email',
      type: 'string'
    },
    'user.phone': {
      label: 'Phone',
      type: 'string'
    },
    'user.activated': {
      label: 'Activated',
      type: 'boolean'
    },
    'user.hasLoggedIn': {
      label: 'Has Logged In?',
      type: 'boolean'
    },
    'user.lastLoginDate': {
      label: 'Last Login Date',
      type: 'string'
    }
  };
  appDefs.pawn.fields.forEach(function (field) {
    columns["fields.".concat(field.handle)] = {
      label: field.label,
      type: field.data_type
    };
  });
  appDefs.pawn.groups.forEach(function (group) {
    columns["descendantGroups.".concat(group.handle, "Count")] = {
      label: "".concat(group.label, " count"),
      type: 'number'
    };
  });
  appDefs.pawn.roles.forEach(function (role) {
    columns["childRoles.".concat(role.handle, "Count")] = {
      label: "".concat(role.label, " count"),
      type: 'number'
    };
    columns["descendantRoles.".concat(role.handle, "Count")] = {
      label: "".concat(role.label, " count"),
      type: 'number'
    };
  });
  return columns;
}();
var getFields = function getFields() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var level = arguments.length > 1 ? arguments[1] : undefined;
  var rows = arguments.length > 2 ? arguments[2] : undefined;
  var levelInfo = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
    return item.handle === rows;
  });
  return levelInfo && levelInfo.fields ? levelInfo.fields.map(function (name) {
    return _objectSpread({
      id: "".concat(prefix, "fields.").concat(name)
    }, allColumns["fields.".concat(name)]);
  }) : [];
};
var getFlatColumnTree = function getFlatColumnTree(level, rows) {
  var result = {};
  var tree = getColumnTree({
    level: level,
    rows: rows
  });
  function traverse(node) {
    node.forEach(function (item, index) {
      if (item.children) {
        traverse(item.children);
      } else {
        result[item.id] = item;
      }
    });
  }
  traverse(tree);
  return result;
};
exports.getFlatColumnTree = getFlatColumnTree;
var getColumnTree = function getColumnTree() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 'roles' : _ref$level,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 'wrong' : _ref$rows,
    _ref$projectFields = _ref.projectFields,
    projectFields = _ref$projectFields === void 0 ? {} : _ref$projectFields;
  var tree = _toConsumableArray(levels[level].tree);
  if (level === 'roles') {
    var infoItem = tree.find(function (child) {
      return child.label === 'Respondent info';
    });
    var fieldsItem = tree.find(function (child) {
      return child.label === 'Respondent fields';
    });
    if (infoItem) {
      // Get user information if it's a fortress user
      var info = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
        return item.handle === rows;
      });
      if (info && info.isFortressUser) {
        var _infoItem$children;
        (_infoItem$children = infoItem.children).unshift.apply(_infoItem$children, ['user.username', 'user.firstName', 'user.lastName', 'user.fullName', 'user.fullNameWithEmail', 'user.fullNameWithUsername', 'user.email', 'user.phone', 'user.activated', 'user.hasLoggedIn', 'user.lastLoginDate']);
      }
    }

    // Get fields
    if (fieldsItem) {
      if (rows === 'respondent') {
        var fields = getFields('', level, rows).filter(function (item) {
          return item.id in projectFields;
        }).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            label: projectFields[item.id].value
          });
        });
        if (fields.length > 0) {
          var _fieldsItem$children;
          (_fieldsItem$children = fieldsItem.children).unshift.apply(_fieldsItem$children, _toConsumableArray(fields));
        }
      } else {
        var _fields = getFields('', level, rows);
        if (_fields.length > 0) {
          var _fieldsItem$children2;
          (_fieldsItem$children2 = fieldsItem.children).unshift.apply(_fieldsItem$children2, _toConsumableArray(_fields));
        }
      }
    }
  }
  var addedGroups = new Set();

  // Get ancestors
  function getAncestors() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var level1 = arguments.length > 1 ? arguments[1] : undefined;
    var rows1 = arguments.length > 2 ? arguments[2] : undefined;
    var info = (0, _get2["default"])(appDefs, "pawn.".concat(level1), []).find(function (item) {
      return item.handle === rows1;
    });
    var key = levels[level1].ancestorKey;
    if (info && info[key] && info[key].length > 0) {
      var _iterator = _createForOfIteratorHelper(info[key]),
        _step;
      try {
        var _loop = function _loop() {
          var group = _step.value;
          if (addedGroups.has(group)) {
            return "continue";
          }
          var groupInfo = appDefs.pawn.groups.find(function (item) {
            return item.handle === group;
          });
          if (groupInfo) {
            addedGroups.add(group);
            tree.push({
              label: groupInfo.label,
              children: [].concat(_toConsumableArray(['group.groupId', 'group.label'].map(function (name) {
                return _objectSpread(_objectSpread({}, allColumns[name]), {}, {
                  id: "".concat(prefix, "ancestorGroups.").concat(group, ".").concat(name),
                  label: "".concat(groupInfo.label, " ").concat(allColumns[name].label)
                });
              })), [{
                label: 'Fields',
                children: getFields("".concat(prefix, "ancestorGroups.").concat(group, "."), 'groups', group)
              }])
            });
            getAncestors('', 'groups', group);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();
          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  if (rows !== 'respondent') {
    getAncestors('', level, rows);
  }

  // Get descendant
  if (level === 'groups') {
    var childRoles = [];
    var childGroups = [];
    var getDescendants = function getDescendants(rows1) {
      var info = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
        return item.handle === rows1;
      });
      if (info && info.containsRoles) {
        childRoles.push.apply(childRoles, _toConsumableArray(info.containsRoles));
      }
      if (info && info.childGroups) {
        childGroups.push.apply(childGroups, _toConsumableArray(info.childGroups));
        info.childGroups.forEach(getDescendants);
      }
    };
    getDescendants(rows);
    if (childRoles.length > 0) {
      tree.push({
        label: 'Role Counts',
        children: childRoles.map(function (child) {
          return "descendantRoles.".concat(child, "Count");
        })
      });
    }
    if (childGroups.length > 0) {
      tree.push({
        label: 'Group Counts',
        children: childGroups.map(function (child) {
          return "descendantGroups.".concat(child, "Count");
        })
      });
    }
  }

  // Get child roles
  if (level === 'roles') {
    var _info = (0, _get2["default"])(appDefs, "pawn.".concat(level), []).find(function (item) {
      return item.handle === rows;
    });
    if (_info && _info.childRoles && _info.childRoles.length > 0) {
      tree.push({
        label: 'Role Counts',
        children: _info.childRoles.map(function (child) {
          return "childRoles.".concat(child, "Count");
        })
      });
    }
  }

  // Add sort information
  (function () {
    var sort = 1;
    function traverse(node) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      node.forEach(function (item, index) {
        if (typeof item === 'string') {
          node[index] = _objectSpread({
            id: item,
            sort: sort++
          }, allColumns[item]);
        } else if (item.children) {
          item.id = "".concat(prefix).concat(item.label);
          traverse(item.children, "".concat(prefix).concat(item.label, "."));
        } else {
          item.sort = sort++;
        }
      });
    }
    traverse(tree);
  })();

  // Remove duplicates
  (function () {
    function traverse(node) {
      node.forEach(function (item) {
        if (item.children) {
          var ids = new Set();
          item.children = item.children.filter(function (child) {
            if (ids.has(child.id)) {
              return false;
            }
            ids.add(child.id);
            return true;
          });
          traverse(item.children);
        }
      });
    }
    traverse(tree);
  })();
  return tree;
};
var _default = getColumnTree;
exports["default"] = _default;